var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyonWhatsapp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 167,
    viewBox: "0 0 172 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6359_86365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.38 58.3002C149.38 58.3002 139.193 38.4027 116.699 35.4585C94.2042 32.5143 78.5242 46.8794 61.9481 54.2462C53.2787 58.1076 43.3797 56.6082 34.1768 58.4761C4.75083 64.4483 -6.33602 101.865 5.92203 123.144C16.5337 141.572 35.2105 151.141 63.6487 153.353C92.0868 155.564 112.035 158.144 137.501 140.089C162.968 122.034 161.271 84.4589 149.38 58.3002Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M149.38 58.3002C149.38 58.3002 139.193 38.4027 116.699 35.4585C94.2042 32.5143 78.5242 46.8794 61.9481 54.2462C53.2787 58.1076 43.3797 56.6082 34.1768 58.4761C4.75083 64.4483 -6.33602 101.865 5.92203 123.144C16.5337 141.572 35.2105 151.141 63.6487 153.353C92.0868 155.564 112.035 158.144 137.501 140.089C162.968 122.034 161.271 84.4589 149.38 58.3002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4276 166.014C112.039 166.014 140.097 164.167 140.097 161.889C140.097 159.611 112.039 157.764 77.4276 157.764C42.816 157.764 14.7578 159.611 14.7578 161.889C14.7578 164.167 42.816 166.014 77.4276 166.014Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.4276 166.014C112.039 166.014 140.097 164.167 140.097 161.889C140.097 159.611 112.039 157.764 77.4276 157.764C42.816 157.764 14.7578 159.611 14.7578 161.889C14.7578 164.167 42.816 166.014 77.4276 166.014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.962 106.136C119.791 109.038 118.591 106.706 118.782 94.5434C118.87 88.8476 119.27 77.2006 125.543 79.7637C131.57 82.2263 123.626 99.4476 123.626 99.4476L120.962 106.136ZM129.573 107.861C129.573 107.861 142.648 94.1707 137.747 89.8528C132.641 85.3883 128.502 96.2773 126.576 101.646C122.467 113.084 122.825 115.681 124.888 113.319L129.573 107.861ZM132.332 120.149C132.332 120.149 144.303 111.585 141.173 107.585C137.918 103.426 133.179 111.141 130.936 114.96C126.143 123.106 126.06 125.146 127.964 123.638L132.332 120.149ZM135.571 132.399C135.571 132.399 147.546 123.835 144.415 119.835C141.156 115.676 136.421 123.391 134.175 127.21C129.386 135.356 129.298 137.4 131.203 135.892L135.571 132.399ZM114.664 107.769C114.664 107.769 97.9132 99.0079 95.1915 104.942C92.3531 111.12 103.911 112.062 109.575 112.406C121.662 113.155 124.026 112.058 121.196 110.751L114.664 107.769ZM117.023 117.402C117.023 117.402 98.876 112.163 97.3797 118.524C95.8209 125.146 107.333 123.755 112.951 122.968C124.938 121.293 127.047 119.739 124.017 119.023L117.023 117.402ZM121.191 127.918C121.191 127.918 105.724 123.91 104.603 129.325C103.44 134.958 113.143 133.513 117.878 132.718C127.973 131.017 129.723 129.66 127.143 129.124L121.191 127.918ZM123.613 136.6C123.613 136.6 108.654 130.963 106.97 136.227C105.22 141.705 115.019 141.303 119.808 141.018C130.028 140.407 131.895 139.239 129.394 138.434L123.613 136.6ZM113.61 92.6253C113.61 92.6253 106.783 71.2996 99.0219 75.1735C90.9527 79.2025 100.272 88.8225 104.94 93.4252C114.889 103.246 117.965 103.937 116.657 100.507L113.61 92.6253Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M120.962 106.136C119.791 109.038 118.591 106.706 118.782 94.5434C118.87 88.8476 119.27 77.2006 125.543 79.7637C131.57 82.2263 123.626 99.4476 123.626 99.4476L120.962 106.136ZM129.573 107.861C129.573 107.861 142.648 94.1707 137.747 89.8528C132.641 85.3883 128.502 96.2773 126.576 101.646C122.467 113.084 122.825 115.681 124.888 113.319L129.573 107.861ZM132.332 120.149C132.332 120.149 144.303 111.585 141.173 107.585C137.918 103.426 133.179 111.141 130.936 114.96C126.143 123.106 126.06 125.146 127.964 123.638L132.332 120.149ZM135.571 132.399C135.571 132.399 147.546 123.835 144.415 119.835C141.156 115.676 136.421 123.391 134.175 127.21C129.386 135.356 129.298 137.4 131.203 135.892L135.571 132.399ZM114.664 107.769C114.664 107.769 97.9132 99.0079 95.1915 104.942C92.3531 111.12 103.911 112.062 109.575 112.406C121.662 113.155 124.026 112.058 121.196 110.751L114.664 107.769ZM117.023 117.402C117.023 117.402 98.876 112.163 97.3797 118.524C95.8209 125.146 107.333 123.755 112.951 122.968C124.938 121.293 127.047 119.739 124.017 119.023L117.023 117.402ZM121.191 127.918C121.191 127.918 105.724 123.91 104.603 129.325C103.44 134.958 113.143 133.513 117.878 132.718C127.973 131.017 129.723 129.66 127.143 129.124L121.191 127.918ZM123.613 136.6C123.613 136.6 108.654 130.963 106.97 136.227C105.22 141.705 115.019 141.303 119.808 141.018C130.028 140.407 131.895 139.239 129.394 138.434L123.613 136.6ZM113.61 92.6253C113.61 92.6253 106.783 71.2996 99.0219 75.1735C90.9527 79.2025 100.272 88.8225 104.94 93.4252C114.889 103.246 117.965 103.937 116.657 100.507L113.61 92.6253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.242 82.7783C102.242 82.7783 119.393 103.802 123.499 114.331C128.217 126.422 131.351 140.352 131.989 151.634",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.086 107.463L122.474 87.415",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.5 114.33L132.128 97.4775",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.24 111.831L104.172 108.133",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.891 123.892L137.515 111.729",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.415 119.884L111.773 119.767",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.04 129.835L117.578 130.254",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.188 136.189L135.789 128.684",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.597 138.978L118.359 138.366",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.962 122.742C151.849 123.542 152.495 121.758 159.026 115.882C162.086 113.126 168.446 107.619 170.172 112.23C171.839 116.661 158.814 120.878 158.814 120.878L153.962 122.742ZM157.297 128.186C157.297 128.186 170.972 128.446 170.834 123.713C170.693 118.788 162.894 121.925 159.11 123.529C151.036 126.955 149.849 128.433 152.103 128.366L157.297 128.186ZM152.145 135.7C152.145 135.7 162.565 137.89 163.14 134.251C163.745 130.481 157.33 131.738 154.204 132.404C147.535 133.844 146.414 134.803 148.148 135.08L152.145 135.7ZM147.252 143.452C147.252 143.452 157.672 145.642 158.251 142.003C158.851 138.233 152.416 139.49 149.315 140.156C142.646 141.601 141.525 142.56 143.259 142.836L147.252 143.452ZM150.015 120.17C150.015 120.17 146.422 106.911 141.938 108.373C137.274 109.897 142.459 116.531 145.06 119.731C150.599 126.553 152.345 127.269 151.649 125.129L150.015 120.17ZM146.043 126.18C146.043 126.18 139.895 113.905 135.79 116.234C131.522 118.654 137.916 124.124 141.096 126.741C147.873 132.32 149.732 132.688 148.619 130.716L146.043 126.18ZM142.517 133.572C142.517 133.572 137.036 123.332 133.618 125.397C130.063 127.546 135.598 132.018 138.345 134.159C144.209 138.719 145.789 138.996 144.793 137.346L142.517 133.572ZM139.112 139.134C139.112 139.134 134.744 128.366 131.13 130.054C127.379 131.809 132.381 136.851 134.881 139.268C140.25 144.44 141.792 144.859 140.987 143.129L139.112 139.134ZM157.451 112.163C157.451 112.163 165.37 98.0322 159.535 95.7916C153.437 93.463 152.929 103.171 152.783 107.937C152.47 118.08 153.616 120.082 154.792 117.678L157.451 112.163Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M153.962 122.742C151.849 123.542 152.495 121.758 159.026 115.882C162.086 113.126 168.446 107.619 170.172 112.23C171.839 116.661 158.814 120.878 158.814 120.878L153.962 122.742ZM157.297 128.186C157.297 128.186 170.972 128.446 170.834 123.713C170.693 118.788 162.894 121.925 159.11 123.529C151.036 126.955 149.849 128.433 152.103 128.366L157.297 128.186ZM152.145 135.7C152.145 135.7 162.565 137.89 163.14 134.251C163.745 130.481 157.33 131.738 154.204 132.404C147.535 133.844 146.414 134.803 148.148 135.08L152.145 135.7ZM147.252 143.452C147.252 143.452 157.672 145.642 158.251 142.003C158.851 138.233 152.416 139.49 149.315 140.156C142.646 141.601 141.525 142.56 143.259 142.836L147.252 143.452ZM150.015 120.17C150.015 120.17 146.422 106.911 141.938 108.373C137.274 109.897 142.459 116.531 145.06 119.731C150.599 126.553 152.345 127.269 151.649 125.129L150.015 120.17ZM146.043 126.18C146.043 126.18 139.895 113.905 135.79 116.234C131.522 118.654 137.916 124.124 141.096 126.741C147.873 132.32 149.732 132.688 148.619 130.716L146.043 126.18ZM142.517 133.572C142.517 133.572 137.036 123.332 133.618 125.397C130.063 127.546 135.598 132.018 138.345 134.159C144.209 138.719 145.789 138.996 144.793 137.346L142.517 133.572ZM139.112 139.134C139.112 139.134 134.744 128.366 131.13 130.054C127.379 131.809 132.381 136.851 134.881 139.268C140.25 144.44 141.792 144.859 140.987 143.129L139.112 139.134ZM157.451 112.163C157.451 112.163 165.37 98.0322 159.535 95.7916C153.437 93.463 152.929 103.171 152.783 107.937C152.47 118.08 153.616 120.082 154.792 117.678L157.451 112.163Z",
    fill: "#A0BDC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.109 101.26C157.109 101.26 154.408 120.759 150.857 128.126C146.772 136.59 140.941 145.117 135.281 151.002",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.812 122.928L164.6 114.347",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.859 128.126L164.022 124.457",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.556 126.23L144.633 114.751",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.469 134.643L159.127 134.342",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.851 131.88L142.211 124.534",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.876 138.174L139.516 132.788",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.57 142.445L149.297 141.75",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.299 144.037L135.609 137.193",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.537 27.7596C31.5242 30.2725 30.4905 28.2496 30.6531 17.7459C30.7281 12.8208 31.0699 2.76102 36.4883 4.97651C41.6941 7.10405 34.8211 21.9759 34.8211 21.9759L32.537 27.7596ZM39.9769 29.2673C39.9769 29.2673 51.2763 17.436 47.0374 13.7254C42.6277 9.86399 39.0516 19.2662 37.3844 23.8982C33.8374 33.7779 34.1625 36.0436 35.9297 33.9831L39.9769 29.2673ZM42.361 39.8799C42.361 39.8799 52.7017 32.4838 49.9967 29.0286C47.1833 25.4353 43.0945 32.0985 41.1522 35.3987C37.0134 42.4388 36.9426 44.1936 38.5848 42.8995L42.361 39.8799ZM45.1785 50.4464C45.1785 50.4464 55.5234 43.0503 52.8184 39.5951C50.005 36.0018 45.9121 42.6692 43.974 45.9652C39.8351 53.0053 39.7601 54.7601 41.4065 53.466L45.1785 50.4464ZM27.1186 29.1668C27.1186 29.1668 12.6265 21.599 10.2716 26.7294C7.82085 32.065 17.8073 32.8733 22.6964 33.1748C33.1164 33.824 35.2003 32.8775 32.7412 31.7467L27.1186 29.1668ZM29.1568 37.5011C29.1568 37.5011 13.456 32.9738 12.1639 38.4811C10.8176 44.202 20.7624 43 25.6182 42.3216C35.9714 40.8683 37.7928 39.5323 35.1753 38.9125L29.1568 37.5011ZM32.7454 46.585C32.7454 46.585 19.3828 43.1215 18.4159 47.7996C17.4072 52.6703 25.7932 51.4181 29.882 50.7312C38.6056 49.2654 40.1144 48.0885 37.8845 47.6279L32.7454 46.585ZM34.8294 54.0859C34.8294 54.0859 21.9086 49.2151 20.4498 53.7634C18.9369 58.4959 27.402 58.1483 31.5409 57.9012C40.3728 57.3735 41.9983 56.3684 39.831 55.669L34.8294 54.0859ZM26.1642 16.0917C26.1642 16.0917 20.2623 -2.33586 13.5685 1.0146C6.59547 4.49907 14.6522 12.8082 18.6785 16.7827C27.2728 25.2719 29.932 25.8666 28.8025 22.9015L26.1642 16.0917Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M32.537 27.7596C31.5242 30.2725 30.4905 28.2496 30.6531 17.7459C30.7281 12.8208 31.0699 2.76102 36.4883 4.97651C41.6941 7.10405 34.8211 21.9759 34.8211 21.9759L32.537 27.7596ZM39.9769 29.2673C39.9769 29.2673 51.2763 17.436 47.0374 13.7254C42.6277 9.86399 39.0516 19.2662 37.3844 23.8982C33.8374 33.7779 34.1625 36.0436 35.9297 33.9831L39.9769 29.2673ZM42.361 39.8799C42.361 39.8799 52.7017 32.4838 49.9967 29.0286C47.1833 25.4353 43.0945 32.0985 41.1522 35.3987C37.0134 42.4388 36.9426 44.1936 38.5848 42.8995L42.361 39.8799ZM45.1785 50.4464C45.1785 50.4464 55.5234 43.0503 52.8184 39.5951C50.005 36.0018 45.9121 42.6692 43.974 45.9652C39.8351 53.0053 39.7601 54.7601 41.4065 53.466L45.1785 50.4464ZM27.1186 29.1668C27.1186 29.1668 12.6265 21.599 10.2716 26.7294C7.82085 32.065 17.8073 32.8733 22.6964 33.1748C33.1164 33.824 35.2003 32.8775 32.7412 31.7467L27.1186 29.1668ZM29.1568 37.5011C29.1568 37.5011 13.456 32.9738 12.1639 38.4811C10.8176 44.202 20.7624 43 25.6182 42.3216C35.9714 40.8683 37.7928 39.5323 35.1753 38.9125L29.1568 37.5011ZM32.7454 46.585C32.7454 46.585 19.3828 43.1215 18.4159 47.7996C17.4072 52.6703 25.7932 51.4181 29.882 50.7312C38.6056 49.2654 40.1144 48.0885 37.8845 47.6279L32.7454 46.585ZM34.8294 54.0859C34.8294 54.0859 21.9086 49.2151 20.4498 53.7634C18.9369 58.4959 27.402 58.1483 31.5409 57.9012C40.3728 57.3735 41.9983 56.3684 39.831 55.669L34.8294 54.0859ZM26.1642 16.0917C26.1642 16.0917 20.2623 -2.33586 13.5685 1.0146C6.59547 4.49907 14.6522 12.8082 18.6785 16.7827C27.2728 25.2719 29.932 25.8666 28.8025 22.9015L26.1642 16.0917Z",
    fill: "#A0BDC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.375 7.58203C16.375 7.58203 31.1922 25.7457 34.7391 34.838C38.8113 45.3082 41.5205 57.3196 42.0706 67.0862",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7812 28.9068L33.8402 11.585",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7344 34.837L42.1867 20.2793",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6404 32.6809L18.0312 29.4854",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6641 43.0997L46.842 32.5918",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3766 39.6408L24.5938 39.5361",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6497 48.2354L29.6094 48.5955",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 53.7211L45.3432 47.2422",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8591 56.1341L30.2891 55.6064",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1697 44.4495C81.3483 45.1405 81.9193 43.6118 87.5461 38.5191C90.1886 36.1403 95.6862 31.3994 97.1741 35.3655C98.6079 39.1934 87.3627 42.8371 87.3627 42.8371L83.1697 44.4495ZM86.0248 49.1569C86.0248 49.1569 97.8368 49.383 97.7201 45.2955C97.5951 41.0362 90.8596 43.7459 87.5919 45.1363C80.6147 48.0931 79.5894 49.3746 81.5359 49.3244L86.0248 49.1569ZM81.59 55.6525C81.59 55.6525 90.5929 57.5456 91.0889 54.3961C91.6099 51.1252 86.0873 52.2183 83.3698 52.8005C77.6096 54.0569 76.6385 54.8945 78.1389 55.1165L81.59 55.6525ZM77.3637 62.3535C77.3637 62.3535 86.3624 64.2423 86.8625 61.097C87.3835 57.8262 81.861 58.9151 79.1434 59.5014C73.3833 60.7578 72.4121 61.5745 73.9126 61.8132L77.3637 62.3535ZM79.7728 42.2507C79.7728 42.2507 76.6635 30.7963 72.7914 32.057C68.7651 33.372 73.2457 39.1055 75.4881 41.8696C80.273 47.7664 81.7859 48.3946 81.1816 46.5351L79.7728 42.2507ZM76.3634 47.4356C76.3634 47.4356 71.02 36.8062 67.4856 38.8249C63.7969 40.9189 69.3237 45.6431 72.0704 47.9004C77.9306 52.7251 79.5352 53.0392 78.5724 51.3347L76.3634 47.4356ZM73.3166 53.8182C73.3166 53.8182 68.5609 44.9562 65.6016 46.7403C62.5298 48.5957 67.3105 52.4612 69.6863 54.3082C74.7504 58.2533 76.1133 58.4963 75.263 57.0639L73.3166 53.8182ZM70.374 58.6261C70.374 58.6261 66.602 49.3244 63.4801 50.7818C60.2291 52.2979 64.5722 56.6451 66.7395 58.7392C71.3576 63.1995 72.6914 63.5722 71.9953 62.0896L70.374 58.6261ZM86.2123 35.3237C86.2123 35.3237 93.0687 23.1154 88.0046 21.1805C82.7321 19.1661 82.2944 27.5548 82.1694 31.6507C81.9026 40.4163 82.8946 42.1209 83.9033 40.0687L86.2123 35.3237Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M83.1697 44.4495C81.3483 45.1405 81.9193 43.6118 87.5461 38.5191C90.1886 36.1403 95.6862 31.3994 97.1741 35.3655C98.6079 39.1934 87.3627 42.8371 87.3627 42.8371L83.1697 44.4495ZM86.0248 49.1569C86.0248 49.1569 97.8368 49.383 97.7201 45.2955C97.5951 41.0362 90.8596 43.7459 87.5919 45.1363C80.6147 48.0931 79.5894 49.3746 81.5359 49.3244L86.0248 49.1569ZM81.59 55.6525C81.59 55.6525 90.5929 57.5456 91.0889 54.3961C91.6099 51.1252 86.0873 52.2183 83.3698 52.8005C77.6096 54.0569 76.6385 54.8945 78.1389 55.1165L81.59 55.6525ZM77.3637 62.3535C77.3637 62.3535 86.3624 64.2423 86.8625 61.097C87.3835 57.8262 81.861 58.9151 79.1434 59.5014C73.3833 60.7578 72.4121 61.5745 73.9126 61.8132L77.3637 62.3535ZM79.7728 42.2507C79.7728 42.2507 76.6635 30.7963 72.7914 32.057C68.7651 33.372 73.2457 39.1055 75.4881 41.8696C80.273 47.7664 81.7859 48.3946 81.1816 46.5351L79.7728 42.2507ZM76.3634 47.4356C76.3634 47.4356 71.02 36.8062 67.4856 38.8249C63.7969 40.9189 69.3237 45.6431 72.0704 47.9004C77.9306 52.7251 79.5352 53.0392 78.5724 51.3347L76.3634 47.4356ZM73.3166 53.8182C73.3166 53.8182 68.5609 44.9562 65.6016 46.7403C62.5298 48.5957 67.3105 52.4612 69.6863 54.3082C74.7504 58.2533 76.1133 58.4963 75.263 57.0639L73.3166 53.8182ZM70.374 58.6261C70.374 58.6261 66.602 49.3244 63.4801 50.7818C60.2291 52.2979 64.5722 56.6451 66.7395 58.7392C71.3576 63.1995 72.6914 63.5722 71.9953 62.0896L70.374 58.6261ZM86.2123 35.3237C86.2123 35.3237 93.0687 23.1154 88.0046 21.1805C82.7321 19.1661 82.2944 27.5548 82.1694 31.6507C81.9026 40.4163 82.8946 42.1209 83.9033 40.0687L86.2123 35.3237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9003 25.8887C85.9003 25.8887 83.5703 42.7373 80.4819 49.1032C76.9516 56.4155 71.9125 63.7614 67.0234 68.8625",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1875 44.6082L92.3741 37.1953",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 49.1023L91.8703 45.9277",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1102 47.4593L75.125 37.542",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5625 54.7313L87.6365 54.4717",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7706 52.3442L73.0312 45.9951",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3338 57.7841L70.7031 53.127",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3438 61.469L79.1539 60.8701",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2422 62.843L67.3281 56.9336",
    stroke: "#8DC6D5",
    strokeWidth: 1.60147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4242 105.863H22.5736C22.1314 105.863 21.7073 106.04 21.3947 106.354C21.082 106.668 20.9064 107.094 20.9064 107.539V140.273C20.9036 140.494 20.9447 140.714 21.0273 140.92C21.1098 141.126 21.2322 141.313 21.3873 141.471C21.5423 141.629 21.7271 141.754 21.9307 141.839C22.1344 141.925 22.3529 141.969 22.5736 141.969H83.5054L92.1122 151.92V107.526C92.1106 107.305 92.0656 107.087 91.9798 106.884C91.894 106.681 91.769 106.497 91.6122 106.342C91.4553 106.188 91.2696 106.066 91.0657 105.984C90.8619 105.902 90.6439 105.861 90.4242 105.863Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2734 124.585C67.2726 123.851 67.4885 123.133 67.8938 122.522C68.299 121.912 68.8755 121.435 69.5502 121.154C70.2249 120.872 70.9675 120.798 71.6842 120.941C72.4008 121.084 73.0592 121.437 73.576 121.955C74.0929 122.474 74.445 123.135 74.5878 123.855C74.7307 124.575 74.6578 125.322 74.3784 126C74.099 126.678 73.6257 127.258 73.0183 127.666C72.411 128.074 71.6968 128.291 70.9663 128.291C69.9876 128.291 69.0489 127.901 68.3565 127.206C67.6641 126.511 67.2745 125.568 67.2734 124.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4609 124.585C51.4601 123.851 51.6761 123.133 52.0816 122.522C52.487 121.911 53.0637 121.435 53.7387 121.153C54.4136 120.872 55.1565 120.798 55.8732 120.941C56.5899 121.084 57.2483 121.438 57.765 121.957C58.2817 122.476 58.6335 123.138 58.7759 123.858C58.9182 124.578 58.8447 125.324 58.5647 126.003C58.2847 126.681 57.8107 127.26 57.2028 127.668C56.5949 128.075 55.8803 128.292 55.1496 128.291C54.1713 128.291 53.2331 127.901 52.5413 127.206C51.8496 126.511 51.4609 125.568 51.4609 124.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6484 124.583C35.6484 123.85 35.8648 123.134 36.2701 122.524C36.6754 121.915 37.2515 121.44 37.9255 121.159C38.5995 120.879 39.3412 120.805 40.0567 120.948C40.7723 121.091 41.4295 121.444 41.9454 121.963C42.4613 122.481 42.8126 123.141 42.9549 123.86C43.0972 124.579 43.0242 125.325 42.745 126.002C42.4658 126.679 41.993 127.258 41.3864 127.665C40.7798 128.072 40.0667 128.29 39.3371 128.29C38.3588 128.29 37.4206 127.899 36.7288 127.204C36.0371 126.509 35.6484 125.566 35.6484 124.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.976 77.5307C127.976 77.5307 128.543 75.156 127.505 73.3426C126.467 71.5292 125.612 72.773 124.858 73.1499C124.104 73.5269 122.687 72.3123 122.12 73.0578C121.553 73.8033 122.216 74.3854 121.932 74.8587C121.649 75.3319 119.665 74.7624 119.381 76.1151C119.098 77.4678 120.607 77.4427 120.04 78.1044C119.473 78.7662 118.152 78.942 118.815 80.1985C119.477 81.4549 120.607 81.1492 120.607 81.6224C120.607 82.0957 119.381 83.0464 120.136 83.9929C120.89 84.9394 121.932 84.2777 122.22 84.7551C122.507 85.2325 122.878 86.556 123.445 86.8491C124.012 87.1423 125.429 86.7528 126.75 84.3824C128.072 82.0119 127.976 77.5307 127.976 77.5307Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.84 96.0964C140.535 96.754 137.989 98.5088 137.989 98.5088C137.986 98.2197 138.047 97.9336 138.168 97.6711C138.351 97.3905 138.481 97.1183 138.585 96.9508C138.615 96.4933 138.465 96.0422 138.168 95.6944C137.822 95.3091 137.547 96.2765 137.397 96.9215C137.247 97.5665 136.242 98.5465 136.288 99.0155C136.373 99.5668 136.486 100.113 136.626 100.653L133.771 102.977C132.875 103.727 130.307 105.071 130.307 105.071C130.022 104.082 129.641 103.122 129.169 102.207C128.17 100.268 127.066 98.3846 125.864 96.5655C124.86 97.9727 125.651 99.916 126.218 102.307C126.785 104.699 129.161 109.641 129.161 109.641C130.546 109.209 131.84 108.525 132.979 107.622C135.096 106.022 137.91 101.65 137.91 101.65C137.91 101.65 138.743 101.277 139.773 100.921C140.802 100.565 140.652 100.264 140.819 99.2459C140.985 98.2282 141.848 96.8419 141.798 96.3142C141.748 95.7865 141.144 95.4389 140.84 96.0964Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.284 84.3613C124.284 84.3613 123.725 87.8667 123.254 89.6676C122.783 91.4685 122.204 91.3722 122.204 91.3722C121.009 90.7589 119.676 90.4702 118.336 90.5346C116.352 90.723 114.085 92.905 115.031 97.8427C115.977 102.78 119.09 107.521 119.09 107.521L117.486 113.498C117.486 113.498 115.935 118.523 114.71 123.185C113.485 127.846 111.772 134.849 111.013 136.273C110.254 137.696 107.42 139.623 105.153 143.97C102.885 148.317 99.7344 156.488 99.7344 156.488L100.568 157.439C100.568 157.439 110.484 146.332 113.034 143.677C115.585 141.022 119.741 134.091 120.87 130.011C121.547 127.566 122.592 125.238 123.967 123.109C123.967 123.109 125.405 131.532 124.651 133.902C123.896 136.273 122.567 140.356 122.667 143.296C122.767 146.236 124.663 157.422 124.663 157.422L126.364 157.514C126.364 157.514 128.064 149.448 129.477 141.952C130.89 134.455 131.653 131.23 131.653 123.524C131.653 115.818 129.102 106.918 128.535 105.683C127.968 104.447 127.872 104.167 127.872 104.167C127.872 104.167 129.194 102.458 129.194 100.938C129.194 99.4175 127.497 96.7497 127.497 96.7497C127.497 96.7497 128.252 95.2336 127.589 93.9981C127.247 93.3024 126.69 92.7368 126.001 92.3857L126.647 89.0645L124.284 84.3613Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.344 110.299L117.486 113.494C117.486 113.494 115.935 118.52 114.71 123.181C113.485 127.843 111.772 134.845 111.013 136.269C110.254 137.693 107.42 139.619 105.153 143.967C102.885 148.314 99.7344 156.485 99.7344 156.485L100.568 157.435C100.568 157.435 110.484 146.329 113.034 143.673C115.585 141.018 119.741 134.087 120.87 130.008C121.547 127.562 122.592 125.235 123.967 123.106C123.967 123.106 125.405 131.528 124.651 133.898C123.896 136.269 122.567 140.352 122.667 143.292C122.767 146.232 124.663 157.423 124.663 157.423L126.364 157.515C126.364 157.515 128.064 149.449 129.477 141.952C130.89 134.455 131.653 131.231 131.653 123.525C131.653 118.47 130.548 112.883 129.631 109.285C123.671 110.617 120.27 110.638 118.344 110.299Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.359 123.105L127.552 119.038",
    stroke: "white",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.506 76.9619C127.506 76.9619 124.588 77.1504 124.105 81.15C123.621 85.1496 124.388 90.2591 127.022 90.9208C129.657 91.5825 132.595 87.1264 132.878 83.332C133.162 79.5376 130.811 76.1997 127.506 76.9619Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.234 86.3759C131.234 86.69 131.096 86.9455 130.929 86.9455C130.763 86.9455 130.625 86.69 130.625 86.3759C130.625 86.0618 130.758 85.8105 130.929 85.8105C131.1 85.8105 131.234 86.0618 131.234 86.3759Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.839 85.2864C128.839 85.5963 128.705 85.8518 128.539 85.8518C128.372 85.8518 128.234 85.5963 128.234 85.2864C128.234 84.9765 128.368 84.7168 128.539 84.7168C128.71 84.7168 128.839 84.9681 128.839 85.2864Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.478 80.1558C131.677 77.911 129.823 76.4242 127.501 76.9603C127.501 76.9603 124.584 77.1487 124.1 81.1483C123.988 82.1044 123.948 83.0676 123.979 84.0297L124.004 84.0884C124.004 84.0884 123.621 82.9702 127.397 82.7817C128.643 82.7063 131.769 79.9631 132.478 80.1558Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.445 80.1018C130.445 80.1018 132.113 78.0916 133.488 79.3145C134.863 80.5374 132.358 83.2429 132.879 84.0303C133.4 84.8176 134.876 83.8544 134.876 83.8544C134.876 83.8544 134.096 85.5296 133.054 85.5296C132.012 85.5296 130.708 84.135 130.708 82.7361C130.703 81.8572 130.615 80.9808 130.445 80.1186",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.445 80.1018C130.445 80.1018 132.113 78.0916 133.488 79.3145C134.863 80.5374 132.358 83.2429 132.879 84.0303C133.4 84.8176 134.876 83.8544 134.876 83.8544C134.876 83.8544 134.096 85.5296 133.054 85.5296C132.012 85.5296 130.708 84.135 130.708 82.7361C130.703 81.8572 130.615 80.9808 130.445 80.1186",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.953 84.1743C124.953 84.1743 123.723 81.4227 123.156 82.8424C122.589 84.2622 123.536 85.883 124.386 85.883",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.953 84.1742C124.953 84.1742 123.723 81.4227 123.156 82.8424C122.589 84.2622 123.536 85.883 124.386 85.883",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.125 97.9132C127.843 97.5833 127.625 97.2024 127.483 96.7908C127.216 95.6436 127.066 94.4718 127.037 93.2938L126.912 93.164C126.7 94.6842 126.033 97.44 124.082 96.3176C122.132 95.1952 120.577 92.0876 119.994 90.6721C119.688 90.583 119.37 90.5406 119.052 90.5464C119.723 91.7065 121.086 94.3492 120.869 96.2213C120.627 98.3153 118.877 102.286 115.617 100.179C116.47 102.757 117.632 105.221 119.077 107.516L117.614 112.961C122.323 115.235 128.034 114.104 130.534 113.413C129.772 109.481 128.838 106.394 128.521 105.703C127.954 104.472 127.859 104.187 127.859 104.187C127.859 104.187 129.18 102.478 129.18 100.958C129.196 100.087 128.625 98.8221 128.125 97.9132Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.953 100.084C126.082 99.7654 126.212 99.4429 126.328 99.1162",
    stroke: "#0E1213",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.836 108.799C122.68 106.393 124.258 103.792 125.542 101.043",
    stroke: "#0E1213",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.594 108.942C121.594 108.942 122.844 107.773 124.878 105.931",
    stroke: "#0E1213",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.43 108.455L127.198 105.833",
    stroke: "#0E1213",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.284 91.192C119.284 91.192 118.151 90.1492 115.696 91.8579C113.241 93.5667 105.968 98.5965 105.693 99.6394C105.417 100.682 116.554 111.027 117.405 111.596C118.255 112.166 119.489 111.408 119.489 111.408C119.489 111.408 122.915 111.827 123.106 111.446C123.298 111.064 121.793 109.272 120.847 108.799C119.901 108.325 117.638 109.636 117.638 109.636C117.638 109.636 113.053 104.464 112.12 102.659C111.737 101.867 111.295 101.105 110.798 100.381L118.355 96.0167",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.284 91.192C119.284 91.192 118.151 90.1492 115.696 91.8579C113.241 93.5667 105.968 98.5965 105.693 99.6394C105.417 100.682 116.554 111.027 117.405 111.596C118.255 112.166 119.489 111.408 119.489 111.408C119.489 111.408 122.915 111.827 123.106 111.446C123.298 111.064 121.793 109.272 120.847 108.799C119.901 108.325 117.638 109.636 117.638 109.636C117.638 109.636 113.053 104.464 112.12 102.659C111.737 101.867 111.295 101.105 110.798 100.381L118.355 96.0167",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.133 110.517L120.208 110.412L122.188 111.354",
    stroke: "#0E1213",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.164 109.781C119.164 109.781 120.206 109.467 120.727 109.781C121.248 110.095 122.603 110.828 122.603 110.828",
    stroke: "#0E1213",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.445 109.176C119.445 109.176 120.558 108.996 121.004 109.176C121.455 109.422 121.874 109.722 122.255 110.068",
    stroke: "#0E1213",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.109 96.791H119.377",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.798 93.672L137.506 99.0913C137.464 99.1874 137.447 99.2921 137.455 99.3965C137.463 99.5008 137.496 99.6016 137.552 99.6902L137.935 100.31C137.996 100.409 138.083 100.491 138.186 100.545C138.289 100.599 138.404 100.624 138.52 100.617C138.637 100.611 138.749 100.573 138.845 100.508C138.942 100.443 139.019 100.353 139.069 100.247L141.632 94.8446C141.691 94.7213 141.709 94.5827 141.685 94.4482C141.661 94.3138 141.596 94.1902 141.499 94.095L140.844 93.4626C140.769 93.3887 140.677 93.3344 140.577 93.3043C140.476 93.2742 140.369 93.2692 140.266 93.2899C140.163 93.3105 140.067 93.3561 139.985 93.4226C139.903 93.4892 139.839 93.5748 139.798 93.672Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.797 101.398C137.012 100.848 137.387 100.376 137.872 100.041C138.436 99.7714 139.031 99.5744 139.644 99.4551C139.644 99.4551 140.273 97.248 140.565 97.5872C140.856 97.9264 140.74 99.6268 140.74 99.6268",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.797 101.398C137.012 100.848 137.387 100.376 137.872 100.041C138.436 99.7714 139.031 99.5744 139.644 99.4551C139.644 99.4551 140.273 97.248 140.565 97.5872C140.856 97.9264 140.74 99.6268 140.74 99.6268",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.685 96.8544C141.582 96.7511 141.444 96.6903 141.299 96.6841C141.154 96.6779 141.012 96.7267 140.901 96.8209C140.518 97.1726 139.93 98.1694 139.305 98.7013",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7322 156.484C99.7322 156.484 96.3061 158.31 95.0807 160.107C93.8553 161.904 94.8556 162.909 97.2022 162.126C99.5488 161.343 100.582 157.435 100.582 157.435L99.7322 156.484Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.672 157.421C124.672 157.421 124.88 160.093 125.885 161.103C126.889 162.112 130.236 163.569 130.47 162.334C130.703 161.098 126.789 158.188 126.789 158.188L126.372 157.513L125.122 157.4L124.672 157.421Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.874 85.002C130.64 85.0958 130.432 85.2443 130.266 85.4351C130.101 85.6259 129.984 85.8536 129.923 86.0992C129.754 86.6216 129.689 87.1723 129.732 87.72L128.406 87.5315",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.977 87.8662C127.07 88.1343 127.237 88.3703 127.459 88.5474C127.68 88.7244 127.946 88.8352 128.227 88.8672",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.922 83.8587C127.922 83.8587 129.014 83.0965 129.96 83.8126",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.875 85.0023C130.875 85.0023 132.25 84.4327 132.25 85.4797",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4241 54.3389H22.5734C22.1313 54.3389 21.7072 54.5154 21.3946 54.8295C21.0819 55.1437 20.9062 55.5698 20.9062 56.0141V100.408L29.5131 90.4568H90.4241C90.6448 90.4568 90.8633 90.4128 91.067 90.3273C91.2706 90.2418 91.4554 90.1166 91.6104 89.9588C91.7655 89.801 91.8879 89.6138 91.9704 89.4082C92.053 89.2025 92.0941 88.9824 92.0913 88.7607V56.035C92.0941 55.8133 92.053 55.5932 91.9704 55.3875C91.8879 55.1819 91.7655 54.9947 91.6104 54.8369C91.4554 54.6791 91.2706 54.5539 91.067 54.4684C90.8633 54.3829 90.6448 54.3388 90.4241 54.3389Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7216 73.0593C45.7216 72.3252 45.5049 71.6076 45.099 70.9973C44.693 70.387 44.116 69.9114 43.441 69.6307C42.766 69.35 42.0233 69.2767 41.3068 69.4202C40.5903 69.5638 39.9324 69.9176 39.4161 70.4369C38.8998 70.9563 38.5484 71.6179 38.4064 72.3379C38.2644 73.058 38.3381 73.8042 38.6182 74.4822C38.8984 75.1601 39.3723 75.7394 39.9802 76.1466C40.588 76.5538 41.3024 76.7707 42.0329 76.7699C42.5177 76.7699 42.9977 76.6739 43.4455 76.4874C43.8933 76.3008 44.3001 76.0274 44.6427 75.6828C44.9853 75.3382 45.2569 74.9291 45.442 74.4789C45.6272 74.0288 45.7222 73.5464 45.7216 73.0593Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5336 73.0577C61.5328 72.3248 61.3157 71.6087 60.9099 70.9997C60.5041 70.3907 59.9277 69.9163 59.2536 69.6364C58.5795 69.3565 57.838 69.2837 57.1227 69.4272C56.4075 69.5707 55.7506 69.924 55.2352 70.4425C54.7197 70.9611 54.3688 71.6215 54.2268 72.3404C54.0848 73.0592 54.1581 73.8043 54.4374 74.4813C54.7167 75.1583 55.1895 75.7369 55.796 76.144C56.4025 76.5511 57.1155 76.7684 57.8449 76.7684C58.3297 76.7684 58.8097 76.6724 59.2575 76.4858C59.7053 76.2993 60.1121 76.0259 60.4547 75.6813C60.7973 75.3367 61.0689 74.9276 61.254 74.4774C61.4391 74.0272 61.5341 73.5448 61.5336 73.0577Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3544 73.0593C77.3544 72.3254 77.1378 71.608 76.7321 70.9978C76.3263 70.3875 75.7495 69.9119 75.0748 69.6311C74.4 69.3502 73.6575 69.2768 72.9412 69.4199C72.2248 69.5631 71.5668 69.9165 71.0504 70.4355C70.5339 70.9544 70.1822 71.6156 70.0397 72.3354C69.8972 73.0552 69.9703 73.8012 70.2499 74.4793C70.5294 75.1573 71.0027 75.7368 71.61 76.1445C72.2172 76.5523 72.9312 76.7699 73.6616 76.7699C74.1465 76.7699 74.6267 76.6739 75.0748 76.4874C75.5228 76.301 75.9299 76.0276 76.2728 75.6831C76.6157 75.3385 76.8877 74.9295 77.0733 74.4793C77.2589 74.0291 77.3544 73.5466 77.3544 73.0593Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8392 36.3369L38.8761 40.9019C38.8077 41.0255 38.766 41.1621 38.7538 41.3029C38.7416 41.4438 38.759 41.5856 38.805 41.7192C38.8511 41.8528 38.9246 41.9751 39.0209 42.0782C39.1172 42.1813 39.234 42.2628 39.3637 42.3175L40.5641 42.8452C41.6811 42.9959 42.7523 42.0076 43.0274 41.6474L45.4615 38.6613L40.8392 36.3369Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8136 23.0277L46.3984 26.4201V51.1674H64.5792V26.8682L56.6392 22.8477L54.8136 23.0277Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5732 25.8434C60.0563 25.2487 60.0563 22.8615 60.0563 22.8615L57.9015 22.1914L56.0842 22.3924L54.267 22.1914L52.1163 22.8615C52.1163 22.8615 52.1163 25.2487 51.5953 25.8434C51.0743 26.4381 49.8906 27.6317 49.8906 27.6317C49.8906 27.6317 50.1866 28.0045 51.141 26.9616C51.6619 26.3732 52.2919 25.8924 52.9958 25.5461C52.9903 25.9734 53.1202 26.3914 53.3667 26.7397C54.2143 27.3472 55.0951 27.9065 56.0051 28.4149V28.4945L56.0717 28.4526L56.1426 28.4945V28.4316C57.0531 27.9242 57.934 27.3649 58.7809 26.7564C59.0275 26.4082 59.1574 25.9901 59.1519 25.5628C59.8565 25.908 60.4867 26.389 61.0066 26.9784C61.9736 28.0212 62.257 27.6485 62.257 27.6485C62.257 27.6485 61.0942 26.4423 60.5732 25.8434Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.875 21.3945V24.255L56.1507 28.5017L58.2639 24.4183V21.4783L53.875 21.3945Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9251 16.6572C51.9251 16.6572 51.4333 14.6093 50.9498 15.5977C50.4663 16.586 51.9251 18.6173 51.9251 18.6173V16.6572Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2188 16.5796C60.2188 16.5796 61.3566 15.1891 61.5192 16.0896C61.6817 16.99 60.3813 18.6024 60.3813 18.6024L60.2188 16.5796Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.156 22.8651C55.0351 22.8651 53.9601 22.4177 53.1676 21.6213C52.375 20.8249 51.9297 19.7447 51.9297 18.6184V10.125H60.3824V18.6184C60.3824 19.7447 59.9371 20.8249 59.1445 21.6213C58.3519 22.4177 57.2769 22.8651 56.156 22.8651Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4609 16.8203C53.4609 16.8203 54.1028 17.5951 55.2157 16.8203H53.4609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4609 16.8203C53.4609 16.8203 54.1028 17.5951 55.2157 16.8203",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9766 16.8203C56.9766 16.8203 57.6184 17.5951 58.7355 16.8203H56.9766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9766 16.8203C56.9766 16.8203 57.6184 17.5951 58.7355 16.8203",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3516 15.5411C53.3516 15.5411 53.9934 14.3559 55.3855 15.2521",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6328 15.289C56.6328 15.289 56.8454 14.7865 57.8124 14.7865C58.0609 14.7703 58.3076 14.8394 58.512 14.9825C58.7164 15.1255 58.8665 15.334 58.9377 15.5738",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3828 19.125L56.0622 19.5187L56.6666 19.1627",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4531 19.6982C54.6636 19.953 54.9606 20.1201 55.2867 20.1673",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0588 12.9856L60.2213 16.579C60.2213 16.579 60.3005 17.069 60.4631 16.089C60.6256 15.109 61.4426 12.4119 61.2758 11.5952C61.1091 10.7785 59.9754 10.7576 59.4878 11.0256C59.0001 11.2936 60.0588 12.9856 60.0588 12.9856Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9296 15.5986C51.9296 15.5986 51.442 11.8293 51.1961 9.8819C50.9502 7.93444 53.5551 7.75854 53.5551 7.75854C53.5551 7.75854 55.3432 6.28434 58.7568 5.8781C62.1704 5.47185 63.7959 6.71571 63.7125 7.59521C63.6292 8.4747 61.6827 9.14479 61.6827 9.14479C61.6827 9.14479 64.0376 9.39189 62.658 10.6986C61.2784 12.0053 59.9738 11.9215 59.9738 11.9215C59.9738 11.9215 61.1951 12.4953 60.4615 12.9015C59.7279 13.3077 54.5305 11.7582 54.5305 11.7582C54.5305 11.7582 54.693 12.7382 53.9594 12.9853C53.2259 13.2324 52.9841 13.1486 52.9049 13.5548C52.8257 13.9611 52.8216 16.4153 52.4173 16.6582C52.013 16.9011 51.9296 15.5986 51.9296 15.5986Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3552 26.5254L39.8281 37.2469L45.6967 39.6592L46.3552 36.2627V26.5254Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3056 36.6943L73.0687 39.8815C73.1371 40.005 73.1787 40.1417 73.191 40.2825C73.2032 40.4233 73.1858 40.5652 73.1398 40.6988C73.0937 40.8324 73.0202 40.9547 72.9239 41.0578C72.8276 41.1609 72.7108 41.2424 72.581 41.297L70.0802 42.3482C69.8739 42.4343 69.6448 42.4485 69.4296 42.3885C69.2143 42.3285 69.0252 42.1979 68.8924 42.0174L66.6875 39.0187L71.3056 36.6943Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5859 26.8682L72.0133 36.8735L66.2365 39.5538L64.5859 36.7143V26.8682Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7223 40.94C38.9516 40.2112 39.2433 39.6835 41.8066 38.5737C44.37 37.4639 48.1587 36.3205 49.2423 35.173C49.4257 34.8003 52.7476 31.3535 52.7476 31.3535C52.7476 31.3535 53.9271 31.1524 54.1439 31.0812C54.6937 31.0413 55.2464 31.0879 55.7819 31.2195C56.0862 31.3283 56.1153 31.5001 55.9903 31.5754C55.6559 31.6613 55.3162 31.7242 54.9733 31.7639L54.8691 31.8183C55.3036 32.174 55.6915 32.5835 56.0236 33.0371C56.0612 33.1543 56.1529 33.1669 55.9194 33.2465C55.686 33.3261 54.9441 32.7942 54.9441 32.7942H54.2606L55.1275 33.3261C55.1275 33.3261 55.9611 34.1344 55.6735 34.3144C55.3859 34.4945 55.2984 34.4862 55.2567 34.3144C55.2151 34.1427 54.644 33.7784 54.644 33.7784L53.477 33.6527C53.8465 33.873 54.2028 34.115 54.544 34.3773C54.7099 34.561 54.8617 34.757 54.9983 34.9636C54.9983 34.9636 54.8941 35.3028 54.519 35.0809C54.1439 34.8589 53.5312 34.461 53.5312 34.461L53.0269 34.3689C52.5037 34.959 51.947 35.5184 51.3597 36.0441C51.0934 36.1947 50.8027 36.2968 50.5011 36.3457V36.3792C49.1483 38.0865 47.579 39.6086 45.8329 40.9065C43.1821 42.7995 41.2481 43.5868 40.3603 43.4193C39.4726 43.2518 38.4889 41.6687 38.7223 40.94Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2702 32.7864L52.8281 32.5352",
    stroke: "#0E1213",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4727 33.6615L52.5391 33.54",
    stroke: "#0E1213",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8776 31.8102L53.2812 31.7725",
    stroke: "#0E1213",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3125 49.3701H65.6898V49.546C65.6898 51.4898 64.9213 53.354 63.5534 54.7285C62.1856 56.103 60.3303 56.8751 58.3958 56.8751H52.6065C50.672 56.8751 48.8167 56.103 47.4489 54.7285C46.081 53.354 45.3125 51.4898 45.3125 49.546V49.3701Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6016 74.8086C59.6016 74.8086 60.5519 77.7863 61.7356 78.9757C62.9193 80.1651 64.9366 80.408 64.8199 78.2637C64.7032 76.1194 61.9731 73.6191 61.9731 73.6191C61.9731 73.6191 59.6016 73.7364 59.6016 74.8086Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9683 73.6201C61.9683 73.6201 55.0953 60.1597 53.1947 56.2271C51.2941 52.2945 49.2851 48.1273 47.3887 47.4321C45.4922 46.7369 42.5288 48.7388 43.004 52.194C43.4791 55.6491 47.9805 61.6046 50.1145 64.3394C52.2486 67.0742 59.5967 74.8096 59.5967 74.8096C59.5967 74.8096 61.0222 75.287 61.9683 73.6201Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.106 74.8086C50.106 74.8086 49.1557 77.7863 47.972 78.9757C46.7883 80.1651 44.771 80.408 44.8877 78.2637C45.0044 76.1194 47.7344 73.6191 47.7344 73.6191C47.7344 73.6191 50.106 73.7364 50.106 74.8086Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7344 73.6201C47.7344 73.6201 54.6074 60.1597 56.4871 56.2271C58.3669 52.2945 60.4009 48.1273 62.2973 47.4321C64.1938 46.7369 67.1572 48.7388 66.682 52.194C66.2069 55.6491 61.7055 61.6046 59.5715 64.3394C57.4374 67.0742 50.0893 74.8096 50.0893 74.8096C50.0893 74.8096 48.6805 75.287 47.7344 73.6201Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5893 52.7213C66.3684 52.3653 65.8974 52.1266 65.0597 51.9591C63.9801 51.7413 61.4377 51.7874 58.6368 51.9591C57.9157 53.2867 57.203 54.7651 56.5028 56.21C54.6063 60.1426 47.75 73.603 47.75 73.603C48.6961 75.2783 50.1216 74.7925 50.1216 74.7925C50.1216 74.7925 57.4697 67.0487 59.6038 64.3223C61.6127 61.7257 65.7724 56.2267 66.5893 52.7213Z",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2753 32.2285H57.3679C57.6067 32.2285 57.8357 32.3238 58.0045 32.4935C58.1734 32.6631 58.2682 32.8932 58.2682 33.1331V40.3659C58.2682 40.5781 58.1843 40.7816 58.035 40.9316C57.8858 41.0816 57.6833 41.1659 57.4721 41.1659H54.1711C53.96 41.1659 53.7575 41.0816 53.6082 40.9316C53.4589 40.7816 53.375 40.5781 53.375 40.3659V33.129C53.3761 32.8898 53.4714 32.6607 53.6402 32.492C53.8089 32.3232 54.0372 32.2285 54.2753 32.2285Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6694 40.6254C73.2192 40.0098 72.7816 39.6203 69.9974 39.369C67.2132 39.1177 63.2619 39.2643 61.8698 38.5314C61.578 38.2382 57.3392 36.0186 57.3392 36.0186C57.3392 36.0186 56.1513 36.207 55.9262 36.207C55.3921 36.3454 54.883 36.5673 54.4174 36.8645C54.1632 37.0614 54.1924 37.2331 54.3341 37.2624C54.6774 37.2393 55.0186 37.1917 55.3552 37.12H55.4719C55.1731 37.5919 54.935 38.0999 54.7634 38.6319C54.7634 38.7576 54.6842 38.7994 54.9301 38.7994C55.176 38.7994 55.7095 38.0582 55.7095 38.0582L56.3639 37.8487L55.7095 38.6319C55.7095 38.6319 55.176 39.6622 55.5011 39.7459C55.8262 39.8297 55.9179 39.7836 55.9179 39.6203C56.0197 39.3668 56.1603 39.1308 56.3347 38.9209L57.4017 38.4267C57.1207 38.7534 56.8604 39.0975 56.6223 39.457C56.5221 39.6832 56.4399 39.9171 56.3764 40.1564C56.3764 40.1564 56.5806 40.4453 56.8682 40.1145C57.1558 39.7836 57.6059 39.2099 57.6059 39.2099L58.0561 38.9628C58.744 39.3614 59.4553 39.7181 60.1859 40.0307C60.4863 40.0865 60.7942 40.0865 61.0945 40.0307V40.06C62.9189 41.244 64.8889 42.1845 66.9547 42.8577C70.0682 43.8042 72.1606 43.9298 72.9358 43.4775C73.711 43.0252 74.1237 41.2453 73.6694 40.6254Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3516 37.87L57.6395 37.1748",
    stroke: "#0E1213",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.375 38.4488L58.2211 38.0342",
    stroke: "#0E1213",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4531 37.1411L56.9536 36.5967",
    stroke: "#0E1213",
    strokeWidth: 0.959372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6909 55.1924L48.4062 55.6112L53.6871 63.3717L52.4367 67.0572C53.5495 68.3136 54.8333 69.7124 56.0045 70.9772L57.1882 70.1396C57.1882 70.1396 58.9054 72.5603 60.6351 74.7465C61.2054 74.5446 61.6758 74.1289 61.948 73.5864C61.948 73.5864 55.075 60.1259 53.1744 56.1933C53.0369 55.8834 52.866 55.5358 52.6909 55.1924Z",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.1077 54.3389H47.8096L54.195 64.5871C54.195 64.5871 47.1094 75.5012 47.1094 76.8079C47.1094 78.1146 47.347 82.0304 49.2351 81.197C51.1232 80.3636 49.7102 75.8572 50.1812 74.9149C50.6522 73.9726 56.0164 70.0525 56.0164 70.0525C56.0164 70.0525 59.6258 71.9455 60.647 73.8218C61.6682 75.698 61.9849 78.6925 62.9311 80.5939C63.8772 82.4953 66.2363 83.0858 66.2363 81.1844C66.2363 79.283 58.7964 65.4038 58.7964 65.4038C58.7964 65.4038 60.4636 63.5066 64.1106 59.5907C65.6289 57.9912 66.9692 56.2302 68.1077 54.3389Z",
    fill: "#0E1213"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6359_86365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170.397,
    height: 166.291,
    fill: "white",
    transform: "translate(0.804688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyonWhatsapp1);
export default __webpack_public_path__ + "static/media/buyonWhatsapp1.75db575e14eb226ff29e83cca8735fc4.svg";
export { ForwardRef as ReactComponent };